<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-4141324">
				<rect
					id="Rectangle_14861"
					data-name="Rectangle 14861"
					width="20"
					height="20"
					transform="translate(60 809)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_22272" data-name="Mask Group 22272" transform="translate(-60 -809)" clip-path="url(#clip-path-4141324)">
			<path
				id="Path_30447"
				data-name="Path 30447"
				d="M11.944,21.446h-.007l-.023-.012q-.2-.109-.393-.224a25.826,25.826,0,0,1-4.353-3.251c-2.36-2.205-4.861-5.473-4.861-9.5A5.484,5.484,0,0,1,7.885,3.077a5.641,5.641,0,0,1,4.423,2.1,5.641,5.641,0,0,1,4.424-2.1,5.483,5.483,0,0,1,5.576,5.385c0,4.026-2.5,7.293-4.861,9.493a25.82,25.82,0,0,1-4.353,3.251q-.195.115-.393.225l-.023.012h-.007a.771.771,0,0,1-.718,0h0Z"
				transform="translate(57.692 806.696)"
				fill="#5d5ee1"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'CommunitySvg',
};
</script>

<style scoped lang="scss"></style>
